// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

//引入全局css
import './assets/css/mmain.css'
//引入elementui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
/* 引入axios */
import axios from 'axios'
Vue.prototype.$http = axios
//引入封装请求
import api from './api/request' // 导入api接口
Vue.prototype.$api = api; // 将api挂载到vue的原型上


Vue.use(ElementUI)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js